import { action, computed, observable } from 'mobx';

import { IConfiguration } from '~/types/server.types';
import { boundMethod } from 'autobind-decorator';

export class ConfigStore {
    @observable _config: IConfiguration = {};
    @observable sessionId: string = null;

    @action
    setConfig(newConfigValues: IConfiguration) {
        this._config = { ...this._config, ...newConfigValues };
    }

    @action
    setSessionId(sessionId: string) {
        this.sessionId = sessionId;
    }

    isE2E() {
        return !!this._config.e2e_env;
    }

    isProduction() {
        return this._config.environment === 'production';
    }

    isStaging() {
        return this._config.environment === 'staging';
    }

    isDevelopment() {
        return this._config.environment === 'development';
    }

    isTest() {
        return this._config.environment === 'test';
    }

    @computed
    get isLoaded() {
        return Object.keys(this._config).length > 0;
    }

    get apiUrl() {
        return this.isDevelopment()
            ? this._config.url
            : 'https:' + this._config.api_urls_prefix + '/';
    }

    get config(): IConfiguration {
        return this._config;
    }

    get statsigE2ETier(): string {
        return this._config.statsig_e2e_tier || 'e2e';
    }

    get statsigApiUrl(): string {
        return this._config.statsig_api_url || 'https://statsigapi.net/v1';
    }

    @boundMethod
    getStripeKey(user: {
        is_real_chargeable_user?: boolean;
        stripe_key?: string;
    }) {
        if (!user) {
            return this.config.stripe_test_key;
        }

        if (user.stripe_key !== undefined) {
            return user.stripe_key;
        }

        // hack alert, I'm only wearing boxershorts and I want to go to sleep. someone fix this tomorrow morning.
        if (typeof user.is_real_chargeable_user === 'undefined') {
            return this.config.stripe_key;
        }

        return user.is_real_chargeable_user
            ? this.config.stripe_key
            : this.config.stripe_test_key;
    }
}
